import { useAppDispatch, useAppSelector } from '../../../setup/store/store.hooks';
import { pushNotificationHelper } from '../helpers/push-notitifcation.helper';
import { setStatus } from '../store/push-notifications.slice';
import { PushNotificationModalDisplay } from './PushNotificationModalDisplay';

export const PushNotificationModal = (): React.ReactElement<any, any> | null => {
    const { status } = useAppSelector(state => state.pushNofications);
    const dispatch = useAppDispatch();

    if (status !== 'asking permission') {
        return null;
    }

    const ask = async () => {
        const permission = await pushNotificationHelper.askPermission();
        const statusToSend = permission === 'default' ? 'unknown permission' : permission;
        dispatch(setStatus({ status: statusToSend }));
    };

    const onHide = () => {
        dispatch(setStatus({ status: 'unknown permission' }));
    };

    return <PushNotificationModalDisplay onHide={onHide} show={true} onAllowClick={ask} />;
};
